<template>
<Box  @close="cerrar(false)" :width="'800px'" v-if="vendedor">
    <template #top>Ver Vendedor</template>
    <template #center>
        <div class="nj-card">
            <div class="nj-cols form c2">
                <div>
                    <div class="nj-label">Nombre</div>
                    <input type="text" class="nj-text" v-model="vendedor.ven_nombre" disabled>
                </div>
                <div>
                    <div class="nj-label">Documento identidad</div>
                    <input type="text" class="nj-text" v-model="vendedor.ven_documento_identidad" disabled>
                </div>
                <div>
                    <div class="nj-label">Correo</div>
                    <input type="text" class="nj-text" v-model="vendedor.ven_correo" disabled>
                </div>
                <div>
                    <div class="nj-label">Teléfono</div>
                    <input type="text" class="nj-text" v-model="vendedor.ven_telefono" disabled>
                </div>
                <div>
                    <div class="nj-label">Estado</div>
                    <select class="nj-select" v-model="vendedor.est_id" disabled>
                        <option v-for="item in estados" :key="item.est_id" :value="item.est_id">{{ item.est_nombre }}</option>
                    </select>
                </div>
            </div>
        </div>
    </template>
</Box>
</template>
<script>
import Toast from "../../util/toast"
import { Box } from "../components"
import { AppService, VendedorService, ResponseStatus } from "../../rest"
import Arrays from "../../util/arrays"

export default {
    name: "ModificarVendedor",
    components: {
        Box
    },
    props: {
        ven_id: {
            type: Number
        },
        status: {
            type: Boolean
        }
    },
    data() {
        return {
            vendedor: null,
        }
    },
    methods: {
        cerrar(condition) {
            this.$emit("close", { componente: 'ver', abrir: false, buscar: condition })
        }
    },
    mounted() {
        // obteniendo los estados
        AppService.getData(["estados"]).then(
            response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.estados = Arrays.filter(response.data.estados, "est_codigo", ["activo", "inactivo"])
                    // buscando al vendedor
                    VendedorService.obtener({
                        vendedor: {
                            ven_id: this.ven_id
                        }
                    }).then(
                        response => {
                            if (ResponseStatus.isSuccess(response)) {
                                this.vendedor = response.data
                            }
                            else {
                                Toast.warn(response.message)
                            }
                        },
                        error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        }
                    )
                }
                else {
                    Toast.warn(response.message)
                }
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )

    }
}
</script>

<style scoped></style>